module.exports = __webpack_public_path__ + "static/media/gubot.f91a5b36.png";